import { ENDPOINTS } from "../endpoint";
import axiosInstance from "../axiosInstance";


export const CreateOrder = async (token, data) => {
    const response = await axiosInstance.post(ENDPOINTS.CREATE_ORDER, data, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    });
    return response.data;
};
export const VerifyOrder = async (token, data) => {
    const response = await axiosInstance.post(ENDPOINTS.VERIFY_ORDER, data, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    });
    return response.data;
};
export const GetMyOrders = async (token) => {
    const response = await axiosInstance.get(ENDPOINTS.GET_MY_ORDERS, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    });
    return response;
};
export const GetMyOrdersById  = async (token, id) => {
    const response = await axiosInstance.get(`${ENDPOINTS.GET_MY_ORDERS_BY_ID}/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    });
    return response;
};